/**
 * The words of the light layer's developer slider (ADR-141's amendment of 2026-10-31, P2.25-T7), shown only on a page opened
 * with `?lights=dev`: a range over the minute of the turn, the sky override and the switch back to the clock; and the names
 * of the energy source kinds the game registers, which the Asset Studio's Light tab offers (ADR-141's amendment of
 * 2026-11-01, decision 6).
 */
export const LIGHT = {
  slider: {
    minute: "Minute of the turn",
    sky: "Sky",
    clock: "Follow the clock",
    skies: {
      none: "Everyday",
      drained: "Drained",
      bloodMoon: "Blood moon",
    },
  },
  sources: {
    fire: "Fire",
    lamp: "Lamp",
    crystal: "Crystal",
  },
} as const;
